import { render, staticRenderFns } from "./ReCaptchaV2.vue?vue&type=template&id=314fd20f&"
import script from "./ReCaptchaV2.vue?vue&type=script&lang=js&"
export * from "./ReCaptchaV2.vue?vue&type=script&lang=js&"
import style0 from "./ReCaptchaV2.vue?vue&type=style&index=0&id=314fd20f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports